import TileLayer from "ol/layer/Tile.js"
import TileWMS from 'ol/source/TileWMS.js';

import {urlGeoserver} from "./globals";

const cultureWmsLayer0 = new TileLayer({
    source: new TileWMS({
        url: urlGeoserver+'ref_geo/wms', // URL du service WMS
        params: {
            'LAYERS': 'ref_geo:cultures',
            'TILED': true,
            'STYLES':'cultures_description'
        },
        serverType: 'geoserver',// Type de serveur WMS (ex: geoserver)
        crossOrigin: 'anonymous'// Permet les requêtes cross-origin (CORS)
    }),
    opacity:0.5,
    visible:false,
    title:"Cultures"
});

const foretWmsLayer0 = new TileLayer({
    source: new TileWMS({
        url: urlGeoserver+'ref_geo/wms', // URL du service WMS
        params: {
            'LAYERS': 'ref_geo:forets',
            'TILED': true,
            'STYLES':'forets_type_peuplement'
        },
        serverType: 'geoserver',// Type de serveur WMS (ex: geoserver)
        crossOrigin: 'anonymous'// Permet les requ
    }),
    opacity:0.5,
    visible:false,
    title:"Forêts"
});

export const paramForetRepresentation = [
    {
        "nom":"Etat",
        "valeurs" : [
            {"id":"forets_type_peuplement","nom":"Feuillus / résineux"},
            {"id":"forets_essence","nom":"Essences"},
            {"id":"forets_forme_tronc","nom":"Forme du tronc"},
        ]
    },
    {
        "nom":"Potentiel",
        "valeurs" : [
            {"id":"forets_bois_oeuvre","nom":"Bois d'oeuvre"},
            {"id":"forets_exposable_humidite","nom":"Usage en extérieur"},
        ]
    },
];
export const paramCultureRepresentation = [
    {
        "nom":"Etat",
        "valeurs" : [
            {"id":"cultures_description","nom":"Cultures à matières"},
        ]
    },
    {
        "nom":"Potentiel",
        "valeurs" : [
            {"id":"cultures_matiere","nom":"Module matières"},
            {"id":"cultures_materiau","nom":"Module matériaux"},
        ]
    },
];

export const foretWmsLayer = foretWmsLayer0;
export const cultureWmsLayer=cultureWmsLayer0;